<template>
  <div class="page-index">
    <Header background-image="images/hero.jpg">
      <h2 class="header__title">
        {{ cardTitle }}
      </h2>

      <h3 class="header__subtitle">
        {{ cardText }}
      </h3>

      <TCard class="header__card">
        <div class="card__form">
          <PostalFormStep :progress-value="0" />
        </div>
      </TCard>

      <span class="header__subtext">
        Comparez jusqu’à 6 spécialistes de votre région
      </span>
    </Header>

    <HomeBlock id="usps">
      <Usps :usps="usps" />
    </HomeBlock>
  </div>
</template>

<script>
import AbstractHomePage from 'chimera/all/components/page/AbstractHomePage'
import HomeBlock from 'chimera/all/components/HomeBlock'
import Usps from 'chimera/all/themes/blueflow/components/Usps'
import Header from 'chimera/all/themes/blueflow/components/layout/Header'
import PostalFormStep from '~/components/form/steps/postal/PostalFormStep'

export default {
  components: {
    Header,
    HomeBlock,
    PostalFormStep,
    Usps,
  },

  extends: AbstractHomePage,

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Comparez tous les spécialistes',
      headDescription:
        "Comparez des entreprises qualifiées sur Comparateurdepompesachaleur.be. Rapide, fiable et uniquement des devis de votre région. Économisez jusqu'à 40%.",
      path: '/',
      usps: [
        {
          title: 'Répondez à quelques questions',
          text: 'Vous nous dites ce que vous cherchez, afin que nous puissions vous mettre en contact avec le bon spécialiste de votre région.',
          logo: require('chimera/all/themes/blueflow/images/usps/pencil.svg'),
        },
        {
          title: 'Obtenez des devis gratuits',
          text: "Vous recevrez jusqu'à six devis de spécialistes répondant à vos besoins. Cela vous permet d'économiser jusqu'à 40%!",
          logo: require('chimera/all/themes/blueflow/images/usps/offer.svg'),
        },
        {
          title: 'Choisissez le bon spécialiste',
          text: "Nous avons déjà consulté les spécialistes, il ne vous reste plus qu'à comparer les devis et choisir.",
          logo: require('chimera/all/themes/blueflow/images/usps/user.svg'),
        },
      ],
      cardTitle: 'Trouvez le spécialiste de votre région',
      cardText:
        "Comparez les devis avant de vous décider et économisez jusqu'à 40% !",
    }
  },
}
</script>
